import {Injectable} from '@angular/core';
import {GraphHelperService} from '../diagram-render/helpers/graph-helper.service';
import {Command} from './commands.template';

@Injectable()
export class UndoService {
  public undoQue: Array<Command> = [];
  public redoQue: Array<Command> = [];

  constructor(private graphHelperSvc: GraphHelperService) {}

  public executeCommand(command: Command, skipUndo: boolean = false) {
    if (!skipUndo) {
      this.undoQue.push(command);
      this.redoQue = [];
    }

    return command.execute();
  }

  public clear() {
    this.redoQue = [];
    this.undoQue = [];
  }

  public undo() {
    if (this.graphHelperSvc.isCellEditing()) {
      return;
    }

    return this.doWork(true);
  }

  public redo() {
    if (this.graphHelperSvc.isCellEditing()) {
      return;
    }

    return this.doWork(false);
  }

  private doWork(undo: boolean = true): Promise<any> {
    if (undo && this.hasUndo()) {
      const command = this.undoQue.pop();

      this.redoQue.push(command);

      return command.reverse();
    } else if (!undo && this.hasRedo()) {
      const command = this.redoQue.pop();

      this.undoQue.push(command);

      return command.execute();
    }
  }

  public hasUndo(): boolean {
    return Boolean(this.undoQue.length);
  }

  public hasRedo(): boolean {
    return Boolean(this.redoQue.length);
  }
}
